/**
 * GoogleAnalyticsCommand.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen, Henrique Campos for Ranj
 **/

import GoogleAnalyticsService from "../../../lib/html5-software-library/src/ranj/analytics/GoogleAnalyticsService";
import SessionModel from "../app/session/model/SessionModel";
import Config from "../core/config/Config";
import GoogleAnalyticsConfig from "./GoogleAnalyticsConfig";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";
import TrackString from "./TrackString";

export default class GoogleAnalyticsCommand {

	/**
	 * @constructor
	 * @param {GoogleAnalyticsService} googleAnalyticsService 
	 * @param {GoogleAnalyticsConfig} googleAnalyticsConfig
	 * @param {Config} config
	 * @param {SessionModel} sessionModel
	 */
	constructor(googleAnalyticsService, googleAnalyticsConfig, config, sessionModel) {
		this._googleAnalyticsService = googleAnalyticsService;
		this._googleAnalyticsConfig = googleAnalyticsConfig;
		this._config = config;
		this._sessionModel = sessionModel;
	}


	execute(event) {
		const service = this._googleAnalyticsService;
		const params = event.params || {};
		switch (event.type) {

			case GoogleAnalyticsEvent.INIT:
				const trackingID = this._googleAnalyticsConfig.trackingId;
				const enabled = this._googleAnalyticsConfig.isEnabled;
				const anonymousIp = this._googleAnalyticsConfig.isAnonymousIp;

				// Defines persistent values, send with every event
				const environment = this._config.getValue(Config.ENVIRONMENT);
				const buildId = this._config.getValue(Config.BUILDID);
				const analyticsVersion = this._config.getValue(Config.ANALYTICS_VERSION);
				const contentVersion = this._config.getValue(Config.CONTENT_VERSION);

				const persistentValues = {};
				persistentValues[TrackString.PERSISTENT_ENVIRONMENT] = environment;
				persistentValues[TrackString.PERSISTENT_BUILD_ID] = buildId;
				persistentValues[TrackString.ANALYTICS_VERSION] = analyticsVersion;
				persistentValues[TrackString.CONTENT_VERSION] = contentVersion;
				persistentValues[TrackString.GAME_SESSION_ID] = this._sessionModel.sessionId;
				persistentValues['anonymize_ip'] = true;

				// Initialize the service.
				service.initialize(trackingID, enabled, anonymousIp, persistentValues);
				break;

			case GoogleAnalyticsEvent.USER:
				// See best practices of using User Id: https://support.google.com/analytics/answer/9213390?hl=en
				const userID = params;
				service.setUserID(userID);
				break;

			case GoogleAnalyticsEvent.USER_PROPERTY:
				service.setUserProperty(params.property, params.value);
				break;

			case GoogleAnalyticsEvent.PERSISTENT_VALUE:
				service.setPersistentValue(params.property, params.value);
				break;

			case GoogleAnalyticsEvent.CLEAR_PERSISTENT_VALUE:
				service.clearPersistentValue(params.property);
				break;

			case GoogleAnalyticsEvent.SESSION_START:
				service.sendEvent(TrackString.EVENT_SESSION_START);
				break;

			case GoogleAnalyticsEvent.SESSION_END:
				service.sendEvent(TrackString.EVENT_SESSION_END);
				break;

			case GoogleAnalyticsEvent.EVENT:
				service.sendEvent(params.name, params.params);
				break;

			case GoogleAnalyticsEvent.ERROR:
				const description = params.description;
				const fatal = params.fatal;
				service.sendException(description, fatal);
				break;
		}
	}
}